import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { IAPIListResponse, IFileHydrated } from '@newroom-connect/library/interfaces';

import { EntityErrorHandlerService } from '../entity-error-handler.service';

@Injectable({
  providedIn: 'root'
})
export class FileErrorHandlerService extends EntityErrorHandlerService {
  /**
   *
   * @param errorKey
   *
   * @returns
   */
  public override handleListError(errorKey = 'ERROR.LIST_FILES_FAILED'): Observable<IAPIListResponse<IFileHydrated>> {
    return super.handleListError(errorKey) as Observable<IAPIListResponse<IFileHydrated>>;
  }

  /**
   *
   * @param errorKey
   *
   * @returns
   */
  public override handleGetError(errorKey = 'ERROR.GET_FILE_FAILED'): Observable<null> {
    return super.handleGetError(errorKey);
  }

  /**
   *
   * @param errorKey
   *
   * @returns
   */
  public override handleCreateError(errorKey = 'ERROR.CREATE_FILE_FAILED'): Observable<null> {
    return super.handleCreateError(errorKey);
  }

  /**
   *
   * @param errorKey
   *
   * @returns
   */
  public override handleUpdateError(errorKey = 'ERROR.UPDATE_FILE_FAILED'): Observable<null> {
    return super.handleUpdateError(errorKey);
  }

  /**
   *
   * @param errorKey
   *
   * @returns
   */
  public override handleDeleteError(errorKey = 'ERROR.DELETE_FILE_FAILED'): Observable<null> {
    return super.handleDeleteError(errorKey);
  }

  /**
   *
   * @param errorKey
   *
   * @returns
   */
  public handleReplaceError(errorKey = 'ERROR.REPLACE_FILE_FAILED'): Observable<null> {
    this.displayAlertErrorMessage(errorKey);

    return of(null);
  }
}
